import axios from 'axios';
export const makeIDVClient = ({ makeUrl, setToken, deleteToken }) => {
    const plainAxios = axios.create();
    return {
        session: { setToken, deleteToken },
        healthCheck: async (signal) => plainAxios.get(makeUrl('/api/v1/health'), { signal })
    };
};
//# sourceMappingURL=client.js.map